var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSetting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 0h24v24H1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#475B7F",
    d: "M22.743 14.523l-1.794-1.041a8.201 8.201 0 000-2.972l1.794-1.042a.514.514 0 00.232-.593 10.555 10.555 0 00-2.304-4.005.503.503 0 00-.623-.097l-1.795 1.041a7.934 7.934 0 00-2.56-1.486V2.25a.507.507 0 00-.394-.495 10.53 10.53 0 00-4.6 0 .51.51 0 00-.396.495v2.083a8.198 8.198 0 00-2.56 1.487L5.95 4.777a.497.497 0 00-.623.097A10.513 10.513 0 003.023 8.88a.51.51 0 00.232.592l1.794 1.042a8.201 8.201 0 000 2.972l-1.794 1.042a.513.513 0 00-.232.592 10.567 10.567 0 002.304 4.006c.16.174.418.215.623.097l1.795-1.042a7.919 7.919 0 002.56 1.487v2.083c0 .238.165.443.396.495a10.53 10.53 0 004.6 0 .507.507 0 00.396-.495v-2.083a8.198 8.198 0 002.56-1.487l1.795 1.042c.205.12.465.08.623-.097a10.48 10.48 0 002.304-4.006.523.523 0 00-.236-.597zm-9.746 1.533c-2.23 0-4.04-1.818-4.04-4.06 0-2.243 1.81-4.06 4.04-4.06s4.04 1.817 4.04 4.06c0 2.242-1.809 4.06-4.04 4.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F9BB3",
    d: "M12.997 14.701c-1.486 0-2.691-1.211-2.691-2.705S11.51 9.29 12.997 9.29c1.486 0 2.691 1.212 2.691 2.706S14.483 14.7 12.997 14.7z"
  }))));
}

export default SvgSetting;